module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#technology",
      toString: function () {
        return this.url;
      }
    }